import { showDeleteFineState } from "@/atoms";
import { useDeleteFine } from "@/services/fines";
import { Button } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { ModalLayout } from "moh-ui";
import { useRecoilState } from "recoil";
import useAuth from "@/hooks/useAuth";
import { useUserCouncil } from "@/hooks/useUserCouncil";

export default function DeleteFineModal() {
    const [show, setShow] = useRecoilState(showDeleteFineState);
    const { user } = useAuth();
  const council = useUserCouncil();
    const queryClient = useQueryClient();

    const {
        mutate: deleteFine,
        isPending: deletingFine,
    } = useDeleteFine();

    const handleDeleteFine = async () => {
        if (!show?.fine) return;

        deleteFine(show.fine.id!, {
            onSuccess: (data) => {
                if (data.success) {
                    notifications.show({
                        title: "Success",
                        message: "Fine deleted successfully",
                        color: "green",
                    });
                    if (user?.roles?.[0]?.roleName === "ADMINCOUNCIL") {
                        queryClient.invalidateQueries({
                            queryKey: ["fines", council?.id],
                        })
                    } else {
                        queryClient.invalidateQueries({
                            queryKey: ["fines"],
                        })
                    }
                    setShow(null);
                } else {
                    notifications.show({
                        title: "Error",
                        message: data.message || "Something went wrong",
                        color: "red",
                    });
                }
            },
            onError: (error) => {
                console.error(error);
                notifications.show({
                    title: "Error",
                    message: error.message || "An error occurred while deleting the fine",
                    color: "red",
                });
            },
        });
    };

    return (
        <ModalLayout
            open={Boolean(show?.show)}
            onClose={() => setShow(null)}
        >
            <div className="sm:flex sm:items-start">
                <div className="text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Delete Fine</h3>
                    <div className="mt-2">
                        <p className="text-sm text-gray-500">
                            Are you sure you want to delete this fine? This action cannot be undone.
                        </p>
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-5 pt-4 border-t">
                <Button
                    color="red"
                    onClick={handleDeleteFine}
                    loading={deletingFine}
                >
                    Delete
                </Button>
                <Button
                    variant="outline"
                    onClick={() => setShow(null)}
                >
                    Cancel
                </Button>
            </div>
        </ModalLayout>
    );
}
